var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/advisoryboard", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.advisoryBoard
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createAdvBoard.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.key,
                              expression: "rules.key"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Member Name",
                            placeholder: "Enter Member Name",
                            "data-vv-name": "key",
                            "cus-name": "key",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.advisoryBoard.key,
                            callback: function($$v) {
                              _vm.$set(_vm.advisoryBoard, "key", $$v)
                            },
                            expression: "advisoryBoard.key"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.value,
                              expression: "rules.value"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Position or role of memeber",
                            placeholder: "Enter Member Position or role",
                            "data-vv-name": "value",
                            "cus-name": "value",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.advisoryBoard.value,
                            callback: function($$v) {
                              _vm.$set(_vm.advisoryBoard, "value", $$v)
                            },
                            expression: "advisoryBoard.value"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Create Advisory Board Member\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Add Advisory Board")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6d19b6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6d19b6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Podcast/CreateAdvisoryBoard.vue
// module id = xcCA
// module chunks = 0